module.exports = __webpack_public_path__ + "img/box-section.7d126f7b.svg";